export const categories = [
  { id: "korean", name: "韩漫", slug: "korean", icon: "ri-earth-line", description: "精选韩国热门漫画，持续更新中" },
  { id: "japanese", name: "日漫", slug: "japanese", icon: "ri-global-line", description: "经典日本漫画，热血与治愈并存" },
  { id: "chinese", name: "国漫", slug: "chinese", icon: "ri-flag-line", description: "优质国产漫画，国风之美尽在其中" },
  { id: "romance", name: "恋爱", slug: "romance", icon: "ri-heart-line", description: "甜蜜恋爱漫画，心动每一页" },
  { id: "action", name: "热血", slug: "action", icon: "ri-fire-line", description: "燃情热血漫画，战斗永不停歇" },
  { id: "fantasy", name: "奇幻", slug: "fantasy", icon: "ri-magic-line", description: "奇妙幻想世界，想象力无边界" },
  { id: "comedy", name: "搞笑", slug: "comedy", icon: "ri-emotion-laugh-line", description: "欢乐搞笑漫画，笑到停不下来" },
  { id: "horror", name: "悬疑", slug: "horror", icon: "ri-ghost-line", description: "悬疑惊悚漫画，心跳加速体验" },
];

export const mangaList = [
  {
    id: 1,
    title: "女神降临",
    category: "korean",
    categoryName: "韩漫",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20romance%20comic%20cover%20featuring%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%20and%20flawless%20makeup%2C%20soft%20pastel%20colors%2C%20clean%20illustration%20on%20white%20background%2C%20manhwa%20aesthetic&width=400&height=560&seq=manga-cover-01&orientation=portrait",
    author: "猫咪",
    status: "连载中",
    updateTime: "2026-08-04",
    description: "丑小鸭逆袭成校园女神的故事。女主通过化妆技术改变外貌，在新学校开始了完全不同的人生，却意外卷入了两个校草之间的感情纠葛。这部漫画不仅展现了青春校园的甜蜜爱恋，更深刻探讨了外貌与内在、自信与成长的永恒主题。",
    views: 1280000,
    rating: 9.5,
    chapters: 186,
    tags: ["校园", "恋爱", "逆袭", "治愈"],
  },
  {
    id: 2,
    title: "我独自升级",
    category: "korean",
    categoryName: "韩漫",
    cover: "https://readdy.ai/api/search-image?query=Korean%20action%20fantasy%20webtoon%20cover%20featuring%20a%20powerful%20male%20hunter%20with%20dark%20armor%20and%20glowing%20blue%20eyes%2C%20dungeon%20background%20with%20monsters%2C%20dramatic%20lighting%2C%20epic%20illustration%20style%20on%20dark%20background&width=400&height=560&seq=manga-cover-02&orientation=portrait",
    author: "Chugong",
    status: "已完结",
    updateTime: "2026-07-28",
    description: "全球最弱E级猎人成振宇，在一次致命的双重地下城任务中几乎丧命，却意外获得了神秘的[系统]能力。从此他可以像游戏角色一样不断升级变强，踏上了成为世界最强猎人的征程。",
    views: 2560000,
    rating: 9.8,
    chapters: 200,
    tags: ["战斗", "奇幻", "升级", "系统"],
  },
  {
    id: 3,
    title: "海贼王",
    category: "japanese",
    categoryName: "日漫",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20cover%20featuring%20a%20young%20pirate%20boy%20with%20straw%20hat%20and%20big%20smile%2C%20ocean%20and%20ship%20background%2C%20vibrant%20colors%2C%20classic%20anime%20illustration%20style%20on%20white%20background&width=400&height=560&seq=manga-cover-03&orientation=portrait",
    author: "尾田荣一郎",
    status: "连载中",
    updateTime: "2026-08-03",
    description: "少年路飞戴着草帽，怀揣着成为海贼王的梦想踏上伟大航路。一路上他召集伙伴，经历无数惊险冒险，挑战强大的敌人，追寻传说中的大秘宝ONE PIECE。",
    views: 5000000,
    rating: 9.9,
    chapters: 1120,
    tags: ["冒险", "热血", "友情", "梦想"],
  },
  {
    id: 4,
    title: "全职高手",
    category: "chinese",
    categoryName: "国漫",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20manhua%20esports%20cover%20featuring%20a%20cool%20male%20gamer%20with%20headphones%2C%20gaming%20keyboard%20and%20mouse%20in%20foreground%2C%20cyberpunk%20style%20with%20neon%20lights%2C%20modern%20illustration%20on%20dark%20background&width=400&height=560&seq=manga-cover-04&orientation=portrait",
    author: "蝴蝶蓝",
    status: "连载中",
    updateTime: "2026-08-02",
    description: "被誉为荣耀教科书的顶尖高手叶修，被俱乐部驱逐后沦落为网吧管理员。但他并未放弃，带着十年游戏经验和一把自制银武千机伞，重新杀回荣耀职业联盟，书写了一段王者归来的传奇。",
    views: 1890000,
    rating: 9.6,
    chapters: 320,
    tags: ["电竞", "热血", "逆袭", "竞技"],
  },
  {
    id: 5,
    title: "看脸时代",
    category: "korean",
    categoryName: "韩漫",
    cover: "https://readdy.ai/api/search-image?query=Korean%20drama%20webtoon%20cover%20showing%20a%20split%20face%20contrast%20between%20an%20unattractive%20and%20handsome%20male%20character%2C%20school%20uniform%2C%20dramatic%20contrast%20lighting%2C%20clean%20manhwa%20art%20style%20on%20gray%20background&width=400&height=560&seq=manga-cover-05&orientation=portrait",
    author: "朴泰俊",
    status: "连载中",
    updateTime: "2026-08-04",
    description: "因为长相丑陋而备受欺凌的朴玄硕，某天醒来发现自己拥有了一个完美的身体。从此他白天是校园男神，晚上变回原来的自己，在两个身份之间体验着完全不同的人生，也逐渐看清了这个看脸世界的真相。",
    views: 2100000,
    rating: 9.4,
    chapters: 450,
    tags: ["校园", "社会", "励志", "双面人生"],
  },
  {
    id: 6,
    title: "咒术回战",
    category: "japanese",
    categoryName: "日漫",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20cover%20featuring%20a%20spiky%20haired%20teenage%20boy%20with%20supernatural%20powers%2C%20cursed%20energy%20visual%20effects%2C%20urban%20Tokyo%20background%2C%20dynamic%20action%20pose%20illustration%20on%20white%20background&width=400&height=560&seq=manga-cover-06&orientation=portrait",
    author: "芥见下下",
    status: "连载中",
    updateTime: "2026-08-01",
    description: "高中生虎杖悠仁吞下了诅咒之王两面宿傩的手指，从此被卷入咒术师与诅咒的战斗世界。他加入东京都立咒术高等专门学校，与同伴们一起对抗强大的诅咒，守护人类的和平。",
    views: 3200000,
    rating: 9.7,
    chapters: 260,
    tags: ["战斗", "超自然", "黑暗", "友情"],
  },
  {
    id: 7,
    title: "大王饶命",
    category: "chinese",
    categoryName: "国漫",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%20featuring%20a%20witty%20young%20man%20in%20traditional%20robes%20with%20a%20mischievous%20expression%2C%20floating%20spiritual%20energy%20around%20him%2C%20ancient%20Chinese%20architecture%20background%2C%20elegant%20ink%20painting%20style&width=400&height=560&seq=manga-cover-07&orientation=portrait",
    author: "会说话的肘子",
    status: "连载中",
    updateTime: "2026-08-03",
    description: "灵气复苏时代，吕树凭借一张毒舌嘴和捡破烂的天赋，在修行界混得风生水起。他靠吐槽收集负面情绪值来提升实力，一路怼天怼地怼空气，成为灵气复苏时代最不按套路出牌的修行者。",
    views: 1560000,
    rating: 9.3,
    chapters: 280,
    tags: ["修仙", "搞笑", "系统", "吐槽"],
  },
  {
    id: 8,
    title: "鬼灭之刃",
    category: "japanese",
    categoryName: "日漫",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20demon%20slayer%20manga%20cover%20featuring%20a%20young%20swordsman%20with%20green%20checkered%20haori%20and%20a%20demon%20girl%2C%20wisteria%20flowers%2C%20traditional%20Japanese%20art%20style%20with%20water%20breathing%20effects%2C%20clean%20white%20background&width=400&height=560&seq=manga-cover-08&orientation=portrait",
    author: "吾峠呼世晴",
    status: "已完结",
    updateTime: "2026-07-15",
    description: "大正时代，少年炭治郎全家被鬼杀害，唯一幸存的妹妹祢豆子却变成了鬼。为了寻找让妹妹恢复为人类的方法，炭治郎踏上了成为鬼杀队剑士的道路，与各种强大的鬼展开殊死搏斗。",
    views: 4500000,
    rating: 9.8,
    chapters: 205,
    tags: ["战斗", "奇幻", "兄妹情", "大正"],
  },
  {
    id: 9,
    title: "甜蜜的谎言",
    category: "romance",
    categoryName: "恋爱",
    cover: "https://readdy.ai/api/search-image?query=Romance%20manhwa%20cover%20featuring%20a%20couple%20embracing%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20warm%20color%20palette%2C%20romantic%20atmosphere%2C%20gentle%20spring%20lighting%2C%20beautiful%20illustration%20on%20cream%20background&width=400&height=560&seq=manga-cover-09&orientation=portrait",
    author: "甜美工厂",
    status: "连载中",
    updateTime: "2026-08-04",
    description: "因为一个谎言，她不得不假装成总裁的未婚妻。原本以为只是一场交易，却在朝夕相处中渐渐沦陷。当她想要坦白一切时，发现对方似乎也隐藏着什么秘密。一场始于谎言的爱情，能否走向真实的幸福？",
    views: 890000,
    rating: 9.2,
    chapters: 95,
    tags: ["总裁", "契约恋爱", "甜蜜", "都市"],
  },
  {
    id: 10,
    title: "进击的巨人",
    category: "japanese",
    categoryName: "日漫",
    cover: "https://readdy.ai/api/search-image?query=Dark%20fantasy%20manga%20cover%20featuring%20a%20giant%20titan%20reaching%20over%20massive%20walls%2C%20survey%20corps%20soldiers%20with%203D%20maneuver%20gear%2C%20dramatic%20and%20intense%20atmosphere%2C%20apocalyptic%20setting%2C%20detailed%20illustration%20style&width=400&height=560&seq=manga-cover-10&orientation=portrait",
    author: "谏山创",
    status: "已完结",
    updateTime: "2026-06-20",
    description: "人类被巨人逼到了三道高墙之内，百年来苟且偷生。少年艾伦目睹母亲被巨人吞噬，立誓要驱逐所有巨人。他加入调查兵团，在一次次与巨人的战斗中，逐渐揭开了这个世界残酷的真相。",
    views: 4100000,
    rating: 9.7,
    chapters: 139,
    tags: ["黑暗", "战斗", "末世", "反转"],
  },
  {
    id: 11,
    title: "斗罗大陆",
    category: "chinese",
    categoryName: "国漫",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20cultivation%20manhua%20cover%20featuring%20a%20young%20man%20with%20blue%20silver%20grass%20martial%20spirit%20and%20hidden%20weapons%2C%20fantasy%20world%20with%20spirit%20beasts%2C%20epic%20adventure%20atmosphere%2C%20detailed%20illustration%20on%20gradient%20background&width=400&height=560&seq=manga-cover-11&orientation=portrait",
    author: "唐家三少",
    status: "连载中",
    updateTime: "2026-08-03",
    description: "唐门外门弟子唐三，因偷学内门绝学而跳崖明志，却意外穿越到斗罗大陆。在这个武魂的世界里，他凭借着前世的记忆和暗器绝学，一步步踏上巅峰，成为一代海神和修罗神的传奇故事。",
    views: 3500000,
    rating: 9.5,
    chapters: 500,
    tags: ["穿越", "武魂", "修炼", "热血"],
  },
  {
    id: 12,
    title: "间谍过家家",
    category: "comedy",
    categoryName: "搞笑",
    cover: "https://readdy.ai/api/search-image?query=Japanese%20comedy%20spy%20family%20manga%20cover%20featuring%20a%20fake%20family%20of%20three%20with%20a%20spy%20father%20in%20suit%2C%20assassin%20mother%2C%20and%20telepath%20daughter%2C%20retro%201960s%20aesthetic%2C%20warm%20and%20funny%20atmosphere%2C%20clean%20illustration&width=400&height=560&seq=manga-cover-12&orientation=portrait",
    author: "远藤达哉",
    status: "连载中",
    updateTime: "2026-08-02",
    description: "西国最强间谍「黄昏」为了执行任务，必须组建一个临时家庭。他找到了妻子约尔和女儿阿尼亚，却不知道妻子是职业杀手，女儿是会读心的超能力者。三个各怀秘密的人组成的虚假家庭，却渐渐产生了真实的羁绊。",
    views: 2800000,
    rating: 9.6,
    chapters: 98,
    tags: ["搞笑", "间谍", "家庭", "温馨"],
  },
];

export const articles = [
  {
    id: 1,
    mangaId: 1,
    title: "女神降临 第186话：最后的告白",
    content: `<p>在毕业典礼的前一天，修豪终于鼓起勇气约出了珠静。夕阳下的校园天台，微风吹拂着珠静的长发。</p>
<p>"珠静啊，我有话想对你说。"修豪的声音有些颤抖。</p>
<p>珠静转过身，望着这个陪伴自己走过三年高中时光的男孩，心跳不由加速。那些一起在图书馆熬夜复习的日子，那些在操场上并肩跑步的午后，那些在美术室偷偷画对方肖像的瞬间——一切都在此刻涌上心头。</p>
<p>"其实……我从第一次见到你就喜欢上你了。不是因为你变漂亮了，而是因为你是你。那个在角落里默默努力、从不放弃的成珠静。"</p>
<p>珠静的泪水夺眶而出。原来真正的爱，从来不是看脸，而是看心。她走上前，紧紧抱住了修豪。</p>
<p>"我也喜欢你，从很久很久以前就开始了。"</p>
<p>夕阳将两个相拥的身影拉得很长很长。这一刻，所有的自卑、所有的不安、所有对外貌的焦虑，都在这个温暖的拥抱中烟消云散。</p>
<p>美丽的外表会老去，但一个勇敢而温柔的内心，才是真正永不褪色的光芒。珠静终于明白——最美的妆容，是自信的笑容。</p>`,
    publishTime: "2026-08-04",
    views: 56800,
    likes: 12300,
  },
  {
    id: 2,
    mangaId: 2,
    title: "我独自升级 第200话：最终之战（完结）",
    content: `<p>黑暗的虚空中，成振宇与暗影君主面对面站立。整个次元都在这一瞬间凝固。</p>
<p>"你以为获得了系统之力，就能挑战我吗？"暗影君主的声音如同来自深渊。</p>
<p>成振宇嘴角微微上扬："不试试怎么知道？"</p>
<p>刹那间，无数暗影战士从振宇身后浮现——贝里昂、伊格里斯、坦克……每一名战士都散发着不逊于君主级别的强大气息。这是振宇一路走来收服的所有暗影军团，是他最强的底牌。</p>
<p>"全军出击！"</p>
<p>战斗在瞬间爆发。技能的光芒撕裂虚空，力量的碰撞震荡天地。振宇手持暗影之刃，在千军万马中直取暗影君主。每一击都蕴含着他不懈努力升到满级的力量，每一次闪避都展现出经历无数生死战斗后锤炼出的本能。</p>
<p>最终，当暗影君主庞大的身躯轰然倒下时，整个次元开始崩塌重建。</p>
<p>振宇站在新世界的中央，暗影军团单膝跪地向他效忠。他终于成为了真正的暗影君主，世界最强猎人。但他知道，真正的升级，从来不仅仅是力量的提升——而是守护所爱之人的决心。</p>
<p>"走吧，该回家了。"他转过身，向着有家人等待的世界踏出了第一步。</p>`,
    publishTime: "2026-07-28",
    views: 125000,
    likes: 35600,
  },
  {
    id: 3,
    mangaId: 5,
    title: "看脸时代 第450话：真实的自己",
    content: `<p>深夜的便利店里，朴玄硕一个人坐在角落吃着泡面。现在是深夜十一点，他正处于自己原本的身体中。</p>
<p>白天，他用完美的身体在学校里如鱼得水。所有人都对他笑脸相迎，老师对他格外偏爱，女生们争相想要接近他。而此刻，便利店的店员甚至懒得抬头看他一眼。</p>
<p>"这就是现实啊。"他苦笑着想。</p>
<p>就在这时，便利店的自动门打开了。走进来的是李智恩——他在这个学校里唯一真心相待的朋友。</p>
<p>朴玄硕下意识想要低头躲闪，但已经来不及了。</p>
<p>"朴……朴玄硕？"李智恩愣住了，但很快，她的脸上露出了和平时一模一样的温暖笑容，"你怎么在这？这么晚还不回家？"</p>
<p>"你……你不觉得我……"玄硕有些语无伦次。</p>
<p>李智恩在他对面坐下，认真地看着他的眼睛："你觉得我在意的是你的脸吗？我在意的是那个会在雨天把伞让给流浪猫的人，是那个明明自己也很累却还愿意帮别人的人。外表会变，但你的心不会。"</p>
<p>那一刻，朴玄硕突然觉得，这个看脸的世界，也许并没有那么糟糕。</p>`,
    publishTime: "2026-08-04",
    views: 78900,
    likes: 19800,
  },
];

export const aboutData = {
  brandName: "贝勒漫画",
  brandIntro: "贝勒漫画网成立于2020年，是国内领先的漫画在线阅读平台。我们致力于为漫画爱好者提供最全面、最优质的漫画阅读体验，涵盖韩漫、日漫、国漫等多种类型，持续更新热门资源，让每一位读者都能在这里找到自己喜欢的作品。",
  mission: "让每一个人都能轻松享受漫画带来的快乐，打造最优质的漫画阅读社区。",
  features: [
    { title: "海量资源", description: "收录数万部热门漫画，每日更新，永不断更", icon: "ri-database-2-line" },
    { title: "高清画质", description: "所有漫画均为高清版本，支持多种设备流畅阅读", icon: "ri-4k-line" },
    { title: "智能推荐", description: "根据您的阅读偏好，智能推荐您可能喜欢的漫画", icon: "ri-flashlight-line" },
    { title: "多端同步", description: "支持网页端、手机App多端同步阅读进度", icon: "ri-smartphone-line" },
    { title: "社区互动", description: "弹幕评论，与其他读者一起分享阅读感悟", icon: "ri-chat-3-line" },
    { title: "正版授权", description: "与多家出版社合作，拥有正版漫画授权", icon: "ri-shield-check-line" },
  ],
  stats: [
    { value: "5000万+", label: "累计用户" },
    { value: "10万+", label: "漫画资源" },
    { value: "99.7%", label: "用户好评率" },
    { value: "24h", label: "全天候更新" },
  ],
  reviews: [
    { user: "漫画迷小王", rating: 5, content: "贝勒漫画真的是我用过最好的漫画网站！更新速度快，资源全，画质清晰，推荐给所有喜欢看漫画的朋友！", date: "2026-07-28" },
    { user: "二次元少女", rating: 5, content: "界面设计很舒服，分类也很清晰，找漫画特别方便。最喜欢的就是阅读进度同步功能，手机电脑无缝切换！", date: "2026-07-25" },
    { user: "热血少年", rating: 5, content: "追了这么久的海贼王和咒术回战，贝勒的更新从来没让我失望过。韩漫国漫资源也很全，五星好评！", date: "2026-07-20" },
    { user: "深夜追漫人", rating: 5, content: "夜猫子党的福音！更新速度快得惊人，经常凌晨就有新章节了。贝勒漫画已经是我每天必刷的网站了。", date: "2026-07-18" },
    { user: "校园漫粉", rating: 4, content: "校园恋爱类漫画资源很丰富，女神降临和看脸时代追了好久了。希望能增加更多评论互动功能！", date: "2026-07-15" },
  ],
  contact: {
    email: "contact@beilemanga.com",
    qq: "1234567890",
    wechat: "beilemanga_official",
    address: "北京市朝阳区望京SOHO T1座 1806室",
    businessHours: "周一至周五 9:00-18:00",
  },
};

export const heroSlides = [
  {
    id: 1,
    title: "女神降临",
    subtitle: "丑小鸭逆袭成校园女神",
    tag: "热门推荐",
    color: "from-rose-500/80 to-orange-500/80",
    mangaId: 1,
  },
  {
    id: 2,
    title: "我独自升级",
    subtitle: "从最弱到最强的逆袭之路",
    tag: "完结推荐",
    color: "from-indigo-600/80 to-violet-600/80",
    mangaId: 2,
  },
  {
    id: 3,
    title: "全职高手",
    subtitle: "王者归来，荣耀再临",
    tag: "国漫精选",
    color: "from-amber-500/80 to-red-500/80",
    mangaId: 4,
  },
];

export const faqs = [
  { question: "贝勒漫画网如何注册账号？", answer: "您可以通过手机号或邮箱快速注册贝勒漫画账号。下载贝勒漫画App后，点击注册按钮，按照提示填写信息即可完成注册，整个过程只需1分钟。" },
  { question: "贝勒漫画App在哪里下载？", answer: "您可以在本页面找到App下载入口，支持iOS和Android双平台。也可以通过各大应用商店搜索「贝勒漫画」直接下载安装。" },
  { question: "贝勒漫画是否免费？", answer: "贝勒漫画提供大量免费漫画资源供您阅读。部分独家内容和最新章节可能需要会员订阅，但我们会持续增加免费内容的数量，让更多读者享受漫画的乐趣。" },
  { question: "如何找到贝勒漫画最新网址入口？", answer: "请收藏本页面（beilemanga.com）作为贝勒漫画官方入口。当网址发生变化时，我们会通过官方社交媒体和App推送通知及时告知新地址。" },
  { question: "贝勒漫画支持哪些设备阅读？", answer: "贝勒漫画支持网页端（PC/Mac）、iOS App和Android App。您的阅读进度、收藏和书签将自动在多设备间同步，随时随地畅快阅读。" },
  { question: "漫画更新频率如何？", answer: "贝勒漫画与多家出版社和作者保持紧密合作，热门漫画通常可以做到与韩国、日本同步更新。每周都有大量新章节上线，确保读者不会错过任何精彩内容。" },
];

export const appDownloadInfo = {
  title: "贝勒漫画App",
  subtitle: "随时随地，想追就追",
  description: "支持iOS与Android双平台，下载即可获得新人专属福利！海量漫画离线缓存，流量不够也能畅快阅读。",
  features: ["高清无广告阅读", "离线缓存省流量", "更新推送不迷路", "弹幕互动更有趣"],
  iosLink: "#",
  androidLink: "#",
};